import {
	CurrencyDollarIcon
} from '@heroicons/vue/24/outline'
import {
	Nav
} from '@/types' // must be imported since file contains an export statement

export const nav: Nav = { 
    name: 'Invoices', 
    to: {name: 'Invoices'}, 
    icon: CurrencyDollarIcon,
    position: 1,
    show: true,
	module: "invoices"
}
